
























































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import moment from "moment";
import { Utils } from "@/service/util";
import { WorkProgressStateData } from "@/model/WorkProgressStateData";
import requestService from "@/service/requestService";
import { Daisha } from "@/model/Daisha";
import { WorkShubetsuCategory } from "@/model/WorkShubetsuCategory";
import { ReservationItem } from "@/model/ReservationItem";
import { WorkShubetsu } from "@/model/WorkShubetsu";
import { ReservationService } from "@/service/ReservationService";
import { Action, Getter } from "vuex-class";
import { MESSAGE } from "@/model/Message";
import vuedraggable from "vuedraggable";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
/** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
import { FunctionSettingService } from "@/service/FunctionSettingService";
/** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
import { ReservationSearchData } from "@/model/ReservationSearchData";
import Pagination from "@/components/common/Pagination.vue";

@Component({
  components: {
    Header,
    draggable: vuedraggable,
    ConfirmDialog
    ,Pagination
  }
})
export default class Reservation extends Vue {
  public utils: Utils = new Utils();
  dialogVisible: boolean = false;
  dialogWorkTypeVisible: boolean = false;
  dialogData: any = {};
  workTypeCategories: WorkShubetsuCategory[] = [];
  workCounts: number[] = [];
  workCountsPerDay: number[] = [];
  arrReserveByCategory: any = [];
  arrWorkCounts: number[][] = [];
  worksForSelect: any = [];
  arrDay: any = [];
//  startDay: any;
//  oldStartDay: any = null;
  reserveList: any = [];
  reserveListAll: any = [];
  reserveByCategory: ReservationItem[][] = [];
  workCategoryNo: string = "0";
  dateSelected: string = "";
  workTypeList: WorkShubetsu[] = [];
  filterKey: string;
  filterValue: string;
  reservService: ReservationService;
  reqService: requestService;
  worksLoading: boolean = true;
  reservationsLoading: boolean = true;
  searchLoading: boolean = true;
  Message: any = {};
  timerRequestData: any = null;
  showDialogSetting: boolean = false;
  dataSetting: any = [];
  selectedUketsukeCd: string | null = null;
  dataDisplay: any = [];
  hoverIndex: number = -1;
  errorMsg: string = "";
/** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
  functionSetting: FunctionSettingService;
/** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
//  searchMode: boolean = false;
  searchData: ReservationSearchData = {
    plateArea: "",
    plateModel: "",
    plateKana: "",
    plateNo: "",
    workShubetsu: "",
    kkUketsukeNm: "",
    kkUketsukeNmKn: "",
    shadaiNo: "",
    staffKensain: [],
    staffSeibishi: [],
    staffHojoseibishi: [],
    shuruiSeibiMenu: [],
    cntSeibiImageType: 0,
    cntCarImageType: 0,
    yoyakuNo: "",
    kkTel: "",
    skNo: "",
    kkNo: "",
    nyuukoPlansStart: "",
    nyuukoPlansEnd: ""
  };
  searchPlansRange: any = [];
  reserveSearchList: any = [];
  shuruiSeibiMenuRaw: any[] = [];
  staffKensainRaw: any[] = [];
  staffSeibishiRaw: any[] = [];
  staffHojoseibishiRaw: any[] = [];
  workShubetsuRaw: any[] = [];

  // このリストの内容は2か所で統一しておく必要がある
  // shakenFE の src\page\factory\reservation.vue
  // shaken_adminFE の src\views\WorkTypeDetail.vue
  shubetsuBgTypelist: any = [
    {"label": "なし" , "css": ""},
    {"label": "入庫予約:赤背景"  , "css": "bg-type-red1"},
    {"label": "入庫予約:赤枠"  , "css": "bg-type-red2"},
    {"label": "行:赤グラデーション"  , "css": "bg-type-red3"},
  ];

  // for pagination
  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  soukouUnitList: any= [];
  dataPageList: any = [];
  itemSizeSelected: number = 100;// 10
  paginationDayList: boolean = false; // 日付毎の予約表示もページングするフラグ
  searchPageList: any = [];
  itemSizeSelectedSearch: number = 100;// 10
  searchCurrentPage: number = 1;
  diagnosticEnabled: boolean = false;
  diagnosticCssZoom: string = "-";
  diagnosticHighDprRule: string = "-";
  diagnosticDevicePixelRatio: string = "-";
  diagnosticViewport: string = "-";
  diagnosticProgressColumnSize: string = "-";
  diagnosticCooperateLabelSize: string = "表示なし";
  diagnosticResizeHandler: () => void = () => this.refreshDiagnostics();

  @Action("clearState", { namespace: "ReservationDetail" })
  clearState: any;

  /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [START] */
  @Getter("isCanQuickMitsumori", { namespace: "FunctionSetting"} )
  isCanQuickMitsumori: any;
  /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [END] */
  @Getter("isUseIppanSeibi", { namespace: "FunctionSetting" })
  isUseIppanSeibi: boolean | null; // システム設定A 一般整備見積

  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

  @Action("setState", { namespace: "ReservationSearchData" })
  setReservationSearchData: any;
  @Action("setCurrentTab", { namespace: "ReservationSearchData" })
  setReservationCurrentTab: any;
  @Action("setCurrentPage", { namespace: "ReservationSearchData" })
  setReservationCurrentPage: any;
  @Action("setCurrentDay", { namespace: "ReservationSearchData" })
  setReservationCurrentDay: any;
  @Action("setNyuukoPlansRange", { namespace: "ReservationSearchData" })
  setReservationNyuukoPlansRange: any;
  @Action("setStartDay", { namespace: "ReservationSearchData" })
  setReservationStartDay: any;
  @Action("toggleSearchMode", { namespace: "ReservationSearchData" })
  toggleReservationSearchMode: any;
  @Action("clearSearchForm", { namespace: "ReservationSearchData" })
  clearReservationSearchForm: any;
  @Action("setStateSession", { namespace: "ReservationSearchData" })
  setReservationSearchDataSession: any;
  @Getter("currentState", { namespace: "ReservationSearchData" })
  currentReservationSearchData: ReservationSearchData;
  @Getter("currentTab", { namespace: "ReservationSearchData" })
  reservationCurrentTab: number;
  @Getter("currentPage", { namespace: "ReservationSearchData" })
  reservationCurrentPage: number;
  @Getter("currentDay", { namespace: "ReservationSearchData" })
  reservationCurrentDay: number;
  @Getter("rangeDay", { namespace: "ReservationSearchData" })
  reservationRangeDay: number;
  @Getter("searchPlansRange", { namespace: "ReservationSearchData" })
  reservationSearchPlansRange: string[];
  @Getter("startDay", { namespace: "ReservationSearchData" })
  reservationStartDay: string;
  @Getter("searchMode", { namespace: "ReservationSearchData" })
  reservationSearchMode: boolean;

  $refs!: {
    errorDialog: ConfirmDialog;
    warnSearchPlansRange: ConfirmDialog;
    warnSeachMax: ConfirmDialog;
    confirmOtherKyotenOne: ConfirmDialog;
    confirmOtherKyotenMultiple: ConfirmDialog;
    paginationDay: Pagination;
    paginationSearch: Pagination;
  };

  created() {
    this.diagnosticEnabled = this.$route.query.s === "1";
    this.Message = MESSAGE;
    this.reservService = new ReservationService();
    this.reqService = new requestService();
    this.loadInspectionMasterRawData();
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
    this.functionSetting = new FunctionSettingService();
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
    moment.locale("ja");
    this.setReservationSearchDataSession();
    this.searchData = { ...this.currentReservationSearchData };
    if (this.reservationCurrentDay < 0 || this.reservationCurrentDay > this.reservationRangeDay * 2) {
      this.setReservationCurrentDay(this.reservationRangeDay);
    }
    if (
      this.reservationStartDay &&
      moment(this.reservationStartDay, "YYYYMMDD", true).isValid()
    ) {
    //  this.startDay = moment(this.reservationStartDay, "YYYYMMDD");
      this.setArrDay();
      this.setDateSelected();
    } else {
      this.setDateToday();
    }
    this.clearState();
    this.reservService.getWorkShubetsuCategories().then((res: any) => {
      if (res && res.length > 0) {
        this.workTypeCategories = res;
        this.worksForSelect = Array.from(res).slice(1);
      }
      this.requestData();
    });

    this.reqService.getReservationSetting().then(res => {
      if (res) {
        this.dataSetting = res;
        this.setDataDisplay();
      }
    });
    this.searchPlansRange = this.reservationSearchPlansRange;
  }

  loadInspectionMasterRawData() {
    this.reqService.getSeibiMenuList().then(
      (res: any) => {
        this.shuruiSeibiMenuRaw = res || [];
      },
      () => {
        this.shuruiSeibiMenuRaw = [];
      }
    );

    this.reqService.getStaffKensain().then(
      (res: any) => {
        this.staffKensainRaw = res || [];
      },
      () => {
        this.staffKensainRaw = [];
      }
    );

    this.reqService.getStaffSeibishi().then(
      (res: any) => {
        this.staffSeibishiRaw = res || [];
      },
      () => {
        this.staffSeibishiRaw = [];
      }
    );

    this.reqService.getStaffHojoseibishi().then(
      (res: any) => {
        this.staffHojoseibishiRaw = res || [];
      },
      () => {
        this.staffHojoseibishiRaw = [];
      }
    );

    this.reqService.getWorkShubetsu().then(
      (res: any) => {
        this.workShubetsuRaw = res || [];
      },
      () => {
        this.workShubetsuRaw = [];
      }
    );
  }

  mounted() {
    if (this.diagnosticEnabled) {
      this.refreshDiagnostics();
      window.addEventListener("resize", this.diagnosticResizeHandler);
    }
    if( this.reservationSearchMode ) {
      // 自動検索
      this.searchLoading = false;
      if( !this.isSearchDisabled() ) {
        this.doSearch();
      }
    } else {
      this.searchLoading = false;
    }
  }

  updated() {
    if (this.diagnosticEnabled) {
      this.refreshDiagnostics();
    }
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.diagnosticResizeHandler);
  }

  refreshDiagnostics() {
    this.$nextTick(() => {
      const table = this.$el.querySelector(".flex-table") as HTMLElement | null;
      const progressColumn = this.$el.querySelector(".columnCell-sknWorkProgressState") as HTMLElement | null;
      const cooperateLabel = this.$el.querySelector(".lb-cooperate") as HTMLElement | null;
      const cssZoom = table ? window.getComputedStyle(table).getPropertyValue("zoom") : "-";
      const progressColumnRect = progressColumn ? progressColumn.getBoundingClientRect() : null;
      const cooperateLabelRect = cooperateLabel ? cooperateLabel.getBoundingClientRect() : null;
      const highDprRule = window.matchMedia("(-webkit-min-device-pixel-ratio: 1.5)").matches;

      this.setDiagnosticValue("diagnosticCssZoom", cssZoom || "1");
      this.setDiagnosticValue("diagnosticHighDprRule", highDprRule ? "true" : "false");
      this.setDiagnosticValue("diagnosticDevicePixelRatio", String(window.devicePixelRatio));
      this.setDiagnosticValue("diagnosticViewport", window.innerWidth + " × " + window.innerHeight);
      this.setDiagnosticValue(
        "diagnosticProgressColumnSize",
        progressColumnRect ? this.formatDiagnosticSize(progressColumnRect) : "表示なし"
      );
      this.setDiagnosticValue(
        "diagnosticCooperateLabelSize",
        cooperateLabelRect ? this.formatDiagnosticSize(cooperateLabelRect) : "表示なし"
      );
    });
  }

  formatDiagnosticSize(rect: ClientRect | DOMRect): string {
    return Math.round(rect.width * 10) / 10 + " × " + Math.round(rect.height * 10) / 10 + " px";
  }

  setDiagnosticValue(key: string, value: string) {
    if ((this as any)[key] !== value) {
      (this as any)[key] = value;
    }
  }

  openColsSettingDialog() {
    this.reqService.getReservationSetting().then(res => {
      if (res) {
        this.dataSetting = res;
        this.setDataDisplay();
      }
    });
    this.showDialogSetting = true;
  }

  setDateToday() {
    const today = moment();
    // this.oldStartDay = this.getReservationStartMoment();
    let oldStartDay = this.reservationStartDay;
    this.setReservationStartDay(today.clone().add(-this.reservationRangeDay, "d").format("YYYYMMDD"));
    this.dateSelected = today.format("YYYYMMDD");
    this.setArrDay();
  //  this.currentDay = this.reservationRangeDay;
    this.setReservationCurrentDay(this.reservationRangeDay);
    return oldStartDay;
  }

  selectToday() {
    // this.setDateToday();
    if (!(this.setDateToday() === this.reservationStartDay)) {
      this.requestData();
    } else {
      this.setData();
    }
  }

  setData() {
    this.filterReserveList();
    if (this.arrReserveByCategory.length > 0) {
      this.workCounts = this.arrWorkCounts[this.reservationCurrentDay];
      this.reserveByCategory = this.arrReserveByCategory[this.reservationCurrentDay];
      this.reserveList = this.reserveByCategory[this.reservationCurrentTab];
      // this.onSetPage(1);
      this.workCountsPerDay = this.reservService.getWorkCountsPerDay(
        this.arrWorkCounts,
        this.reservationCurrentTab
      );
    } else {
      const n = this.reservationRangeDay * 2 + 1;
      let workCountsPerDay = Array(n).fill(0);
      this.$set(this, "workCountsPerDay", workCountsPerDay);
    }
   
    this.reservationsLoading = false;
  }

  setArrDay() {
    this.arrDay = this.reservService.getDayTabs();
  }

  requestData() {
    this.reserveListAll = [];
    this.reservationsLoading = true;
    if (this.timerRequestData) {
      clearTimeout(this.timerRequestData);
      this.timerRequestData = null;
    }
    this.timerRequestData = setTimeout(() => {
      this.reservService
        .requestData(
          this.workTypeCategories.length
        )
        .then((res: any) => {
          if (res.length > 0) {
            this.reserveListAll = res;
            this.setData();
          } else {
            this.setData();
            this.reservationsLoading = false;
          }
        },(error: any) => {
          if (error) {
            this.setData();
            this.onError(error);
          }
        });
    }, 300);
  }

  isActive(index: number) {
    return this.reservationCurrentTab === index;
  }

  isActiveDay(index: number) {
    return this.reservationCurrentDay === index;
  }

  selectTab(tab: WorkShubetsuCategory, index: number) {
    this.workCategoryNo = tab.workShubetsuCategoryId.toString();
    this.setReservationCurrentTab(index);
    this.setReservationCurrentPage(1);
    this.setData();
  }

  selectDay(day: any, index: number) {
    this.dateSelected = day.value;
    this.setReservationCurrentDay(index);
    this.setReservationCurrentPage(1);
    this.setData();
  }

  setDateSelected() {
    if (this.arrDay.length > 0) {
      this.dateSelected = this.arrDay[this.reservationCurrentDay].value;
    }
  }

  getReservationStartMoment() {
    return moment(this.reservationStartDay, "YYYYMMDD");
  }

  prevWeek() {
    this.setReservationCurrentDay(this.reservationRangeDay);
    const prevStartDay = this.getReservationStartMoment().add(-this.reservationRangeDay, "d");
    this.setReservationStartDay(prevStartDay.format("YYYYMMDD"));
    this.setArrDay();
    this.setDateSelected();
    this.requestData();
  }

  nextWeek() {
    this.setReservationCurrentDay(this.reservationRangeDay);
    const nextStartDay = this.getReservationStartMoment().add(this.reservationRangeDay, "d");
    this.setReservationStartDay(nextStartDay.format("YYYYMMDD"));
    this.setArrDay();
    this.setDateSelected();
    this.requestData();
  }

  toggleSearchMode(isClose: boolean = false) {
    if (isClose) {
      // 検索条件や結果を初期化する
      this.clearSearch();
  //    this.clearReservationSearchForm();
  //    this.searchData = { ...this.currentReservationSearchData };
  //    this.searchPlansRange = [];
  //    this.reserveSearchList = [];
  //    this.searchPageList = [];
    }
    this.toggleReservationSearchMode();
  }

  indexMethod(index: number) {
    return index + 1;
  }

  rowClassName(rowobj: any, isNew: boolean = false) {
    let row: any;
    if (rowobj.row) {
      row = rowobj.row;
    } else {
      row = rowobj;
    }
    if (row.progressKbn == 3 || row.sknWorkProgressState == 14) {
      return "gray-bg";
    }
    if (row.sknState == "割当中") {
      return "red-bg";
    }
    if (row.progressNm == "納車") {
      return "gray-bg";
    }
    return "";
  }

  rowClassShubetsuBgTypeName(rowobj: any, isNew: boolean = false) {
    if (rowobj.workShubetsuBgTypeNo != "" && rowobj.workShubetsuBgTypeNo > 0 ) {
      if (this.shubetsuBgTypelist.length > rowobj.workShubetsuBgTypeNo) {
        return this.shubetsuBgTypelist[rowobj.workShubetsuBgTypeNo].css;
      }
    }
    return "";
  }

  onHover(i: number) {
    this.hoverIndex = i;
  }

  onLeave() {
    this.hoverIndex = -1;
  }

  rowWorktypeClassName(rowobj: any) {
    const { rowIndex } = rowobj;
    if (rowIndex % 2 == 1) {
      return "gray-bg";
    }
    return "";
  }

  onClickDetail(row: any, e: any) {
    if (e) {
      e.stopPropagation();
    }
    if (row.progressKbn != 3) {
      if ( row.currentKyotenCount == 0 && row.otherKyotenCount == 1 ) {
        this.selectedUketsukeCd = row.uketsukeCd;
        this.$refs.confirmOtherKyotenOne.onOpen();
        return;
      }　else if ( row.currentKyotenCount == 0 && row.otherKyotenCount > 1 ) {
        this.selectedUketsukeCd = row.uketsukeCd;
        this.$refs.confirmOtherKyotenMultiple.onOpen();
        return;
      }

      this.goToCustomerDetail(row.uketsukeCd);
    }
  }

  onConfirmOpenDetail() {
    if (this.selectedUketsukeCd === null) {
      return;
    }
    this.goToCustomerDetail(this.selectedUketsukeCd);
    this.selectedUketsukeCd = null;
  }

  onCancelOpenDetail() {
    this.selectedUketsukeCd = null;
  }

  /**
   * 顧客詳細の画面に遷移する
   */
  goToCustomerDetail( uketsukeCd: string ) {
    this.$router.push({
      name: "customer",
      params: { code: uketsukeCd }
    });
  }

  heiseiDate(date: string) {
    return this.utils.getJapanDate(date, "YYYYMMDD");
  }

  getStatusColor(stateId: number) {
    const obj = WorkProgressStateData[stateId];
    if (obj) {
      return obj.color;
    }
    return "";
  }

  // onSetPage(page: number) {
  //   if (
  //     this.reserveListAll.length > 0 &&
  //     this.reserveListAll[this.currentDay].length > 0
  //   ) {
  //     const list = this.reserveByCategory[this.reservationCurrentTab];
  //     if (list.length > 0) {
  //       const end = page * this.pageSize;
  //       const start = end - this.pageSize;
  //       this.reserveList = list.slice(start, end);
  //     } else {
  //       this.reserveList = [];
  //     }
  //   } else {
  //     this.reserveList = [];
  //   }
  //   this.reservationsLoading = false;
  // }

  get reserveListData() {
    // ページングが有効な時はページングの返り値の配列を渡す
    if (this.paginationDayList) {
      return this.dataPageList;
    } else {
      return this.reserveList;
    }
  }

  get reserveListLength() {
    if (this.reserveByCategory && this.reserveByCategory.length > 0) {
      return this.reserveByCategory[this.reservationCurrentTab].length;
    }
    return 0;
  }

  openDialogDaisha(daisha: Daisha) {
    this.dialogVisible = true;
    if (daisha) {
      const period = {
        period:
          this.heiseiDate(daisha.daishaRentStartYmd) +
          "~" +
          this.heiseiDate(daisha.daishaRentEndYmd)
      };

      this.dialogData = Object.assign(daisha, period);
    }
  }

  getTime(strTime: string) {
    if (strTime) {
      if (this.isNextageCustom && strTime == "00:00") { return "終日"; }
      return this.utils.removeLeadingZero(strTime.slice(0, 1)) + strTime.slice(1);// :00表示
    }
    return "";
  }

//  get searchPlansRange(): string[] {
//    return this.reservationSearchPlansRange;
//  }

  setSearchPlansRange(value: string[] | null) {
    this.setReservationNyuukoPlansRange(value);
    const searchData: ReservationSearchData = {
      ...this.currentReservationSearchData
    };
    this.searchData.nyuukoPlansStart = searchData.nyuukoPlansStart;
    this.searchData.nyuukoPlansEnd = searchData.nyuukoPlansEnd;
    if (!this.checkSearchPlansRange()) { 
      // 警告
      this.$refs.warnSearchPlansRange.onOpen();
    }
  }

  // 入庫予定日の指定が3カ月以内の範囲に収まっていることを確認
  checkSearchPlansRange() {
    const startDate = moment(this.searchData.nyuukoPlansStart, "YYYYMMDD", true);
    const endDate = moment(this.searchData.nyuukoPlansEnd, "YYYYMMDD", true);
    if (!startDate.isValid() || !endDate.isValid()) { return true; }
    return endDate.isSameOrBefore(startDate.clone().add(3, "months"), "day");
  //  if (!isWithinThreeMonths) { return true; }
  }

  // 検索条件が有効である事、検索中ではない事を確認 (trueでロック)
  isSearchDisabled() {
    if( this.searchLoading ) { return true; }
    const shadaiNo = (this.searchData.shadaiNo || "").trim();
    const isShadaiNoProvided = shadaiNo.length >= 4;
    const isAllKeywordEmpty =
      this.searchData.plateArea.trim() === "" &&
      this.searchData.plateModel.trim() === "" &&
      this.searchData.plateKana.trim() === "" &&
      this.searchData.plateNo.trim() === "" &&
      (this.searchData.workShubetsu || "") === "" &&
      !isShadaiNoProvided &&
      this.searchData.kkUketsukeNm.trim() === "" &&
      (this.searchData.kkUketsukeNmKn || "").trim() === "" &&
      (this.searchData.yoyakuNo || "").trim() === "" &&
      (this.searchData.kkTel || "").trim() === "" &&
      (this.searchData.skNo || "").trim() === "" &&
      (this.searchData.kkNo || "").trim() === "" &&
      (this.searchData.staffKensain || []).length === 0 &&
      (this.searchData.staffSeibishi || []).length === 0 &&
      (this.searchData.staffHojoseibishi || []).length === 0 &&
      (this.searchData.shuruiSeibiMenu || []).length === 0 &&
      (this.searchData.cntSeibiImageType == null || this.searchData.cntSeibiImageType === 0) &&
      (this.searchData.cntCarImageType == null || this.searchData.cntCarImageType === 0);
    const hasStartDate = this.searchData.nyuukoPlansStart.trim() !== "";
    const hasEndDate = this.searchData.nyuukoPlansEnd.trim() !== "";
    if (hasStartDate && hasEndDate) {
    //  const startDate = moment(this.searchData.nyuukoPlansStart, "YYYYMMDD", true);
    //  const endDate = moment(this.searchData.nyuukoPlansEnd, "YYYYMMDD", true);
    //  if (!startDate.isValid() || !endDate.isValid()) { return true; }
    //  const isWithinThreeMonths = endDate.isSameOrBefore(startDate.clone().add(3, "months"), "day");
    //  if (!isWithinThreeMonths) { return true; }
      if (!this.checkSearchPlansRange()) { return true; }
    }
    const hasOnlyOneDate = hasStartDate == false || hasStartDate !== hasEndDate;
    return isAllKeywordEmpty && hasOnlyOneDate;
  }

  doSearch() {
    const searchDataFromStore: ReservationSearchData = {
      ...this.currentReservationSearchData
    };
    this.setReservationSearchData({
      ...searchDataFromStore,
      isSearch: true,
      plateArea: this.searchData.plateArea,
      plateModel: this.searchData.plateModel,
      plateKana: this.searchData.plateKana,
      plateNo: this.searchData.plateNo,
      workShubetsu: this.searchData.workShubetsu,
      kkUketsukeNm: this.searchData.kkUketsukeNm,
      kkUketsukeNmKn: this.searchData.kkUketsukeNmKn,
      shadaiNo: this.searchData.shadaiNo,
      staffKensain: this.searchData.staffKensain,
      staffSeibishi: this.searchData.staffSeibishi,
      staffHojoseibishi: this.searchData.staffHojoseibishi,
      shuruiSeibiMenu: this.searchData.shuruiSeibiMenu,
      cntSeibiImageType: this.searchData.cntSeibiImageType,
      cntCarImageType: this.searchData.cntCarImageType,
      yoyakuNo: this.searchData.yoyakuNo,
      kkTel: this.searchData.kkTel,
      skNo: this.searchData.skNo,
      kkNo: this.searchData.kkNo,
      nyuukoPlansStart: this.searchData.nyuukoPlansStart,
      nyuukoPlansEnd: this.searchData.nyuukoPlansEnd
    });

    this.searchLoading = true;
  //  if (this.timerRequestData) {
  //    clearTimeout(this.timerRequestData);
  //    this.timerRequestData = null;
  //  }
  //  this.timerRequestData = setTimeout(() => {
    this.reservService.requestData2().then((res: any) => {
      if (res.length > 0) {
        this.reserveSearchList = res;
        this.searchLoading = false;
        // データ量を軽減するページングが未実装につき件数上限が設定されているので
        // 上限に達している時は警告を出す
        if ( res.length >= 100) {
          this.$refs.warnSeachMax.onOpen();
        }
      } else {
        this.reserveSearchList = [];
        this.searchLoading = false;
      }
    },(error: any) => {
      if (error) {
        this.reserveSearchList = [];
        this.searchLoading = false;
        this.onError(error);
      }
    });
  //  }, 1300);
  }

  clearSearch() {
    this.clearReservationSearchForm();
    this.searchData = { ...this.currentReservationSearchData };
    this.searchPlansRange = this.reservationSearchPlansRange;
    this.reserveSearchList = [];
    this.searchPageList = [];
    this.searchCurrentPage = 1;
  }

  onSearch(filterOption: any) {// 後でsearchboxも潰すこと
    if (filterOption) {
      this.filterValue = this.utils.toASCII(filterOption.value);// 文字フィルタ
      this.filterKey = filterOption.key;
      this.setData();
    }
  }

  onSearchPageChange(page: number) {
    this.searchCurrentPage = page;
  }

  onSearchPageSize() {
    // サイズ変更に伴いページを初期化する
    this.searchCurrentPage = 1;
  }

  calcSearchPageNo(base: number) {
    if (this.reserveSearchList.length === 0) {
      return 0;
    }
    const page = this.searchCurrentPage;
    return ( ( page - 1 ) * this.itemSizeSelectedSearch ) + base;
  }

  calcSearchPageMax() {
    if (this.reserveSearchList.length === 0) {
      return 0;
    }
    const page = this.searchCurrentPage;
    if( page * this.itemSizeSelectedSearch > this.reserveSearchList.length ) {
      return this.reserveSearchList.length;
    } else {
      return page * this.itemSizeSelectedSearch;
    }
  }

  filterReserveList() {
    let {
      arrWorkCounts,
      arrReserveByCategory
    } = this.reservService.filterReserveList(
      this.reserveListAll,
      this.workTypeCategories,
      this.filterKey,
      this.filterValue 
    );
    this.arrWorkCounts = arrWorkCounts;
    this.arrReserveByCategory = arrReserveByCategory;
  }

  onShowDialogWorkType() {
    this.worksLoading = true;
    this.dialogWorkTypeVisible = true;
    this.reqService.getWorkShubetsu().then(
      (res: any) => {
        this.workTypeList = res;
        this.worksLoading = false;
      },
      (err: any) => {
        this.worksLoading = false;
      }
    );
  }

  getTorokubango(row: any): string {
    return (
      row.srPlateAreaNm +
      row.srPlateModelNm +
      row.srPlateKanaNm +
      "<br/>" +
      row.srPlateNo
    );
  }

  onUpdateWorkShubetsu(row: WorkShubetsu) {
    row.changed = true;
  }

  onClickShubetsuBgType(row: WorkShubetsu) {
    // worksForSelectのセレクト動作の内、基本設定と設定なしの切り替え動作を代替する
    row.changed = true;
    if (row.isSelectedDecoration) {
      row.workShubetsuDecorationId = 1;
    } else {
      row.workShubetsuDecorationId = 0;
    }
    
  }

  OnChangeWorkCate(row: WorkShubetsu) {
    row.changed = true;
    row.isSelected = true;
  }

  saveWorkType() {
    this.dialogWorkTypeVisible = false;
    this.reservService.saveWorkShubetsu(this.workTypeList).then(
      (msg: any) => {
        this.$message.info(msg);
        this.requestData();
      },
      (error: any) => {
        // console.log(error);
        this.$message.error("error");
      }
    );
  }

  disabledChkisSelected(row: WorkShubetsu) {
    return row.workShubetsuCategoryId == null;
  }

  saveDataSetting() {
    this.dataDisplay.forEach((data: any) => {
      this.dataSetting.map((temp: any, index: number) => {
        if (data.columnKey === temp.columnKey) {
          temp.displayOrder = data.displayOrder;
        }
      });
    });
    this.setDataDisplay();
    this.reqService.updateReservationSetting(this.dataSetting);
    this.showDialogSetting = false;
  }

  setDataDisplay() {
    let temp: any[] = [];
    temp.push({
      columnId: "0",
      columnNm: "No",
      columnKey: "no",
      isDisplay: 1,
      displayOrder: 0
    });
    this.dataSetting.forEach((data: any) => {
      if (data.isDisplay === 1) {
        temp.push({ ...data });
      }
    });
    temp.push({
      columnId: "99",
      columnNm: "詳細",
      columnKey: "detail",
      isDisplay: 1,
      displayOrder: 99
    });
    temp.sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1));
    this.dataDisplay = [...temp];
  }

  saveOrderCols() {
    this.dataDisplay.map((data: any, i: number) => {
      data.displayOrder = i;
    });
    this.reqService.updateReservationSetting(this.dataDisplay);
  }

  checkMove(event: any) {
    const index: number = event.draggedContext.index;
    const futureIndex: number = event.draggedContext.futureIndex;
    let isMove: boolean = true;
    if (index === 0 || futureIndex === 0) {
      isMove = false;
    }
    if (
      index === this.dataDisplay.length - 1 ||
      futureIndex === this.dataDisplay.length - 1
    ) {
      isMove = false;
    }
    return isMove;
  }

  onError(res: any) {
    if( !this.reservationSearchMode ) {
      // 予約リスト側のエラーの場合は初期化
      this.reservationsLoading = false;
      this.$set(this, "reserveList", []);
      this.$set(this, "reserveListAll", []);
    } else {
      this.searchLoading = false;
    }
    if (res.status !== 204) {
      if (res.status < 500 && res.rsltComment) {
        this.errorMsg = res.rsltComment;
      } else {
        this.errorMsg = MESSAGE.SystemError;
      }
      this.$refs.errorDialog.onOpen();
    }
  }

  onQuick() {
    this.$router.push({ name: "quickinfo"} );
  }

  get isDebug() {
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
    // let debug: any = localStorage.getItem("isDebug");
    // return debug == "1";
    // return this.functionSetting.isDebug();
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
    /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [START] */
    // let debug: any = localStorage.getItem("isDebug");
    // return debug == "1";
    return this.isCanQuickMitsumori;
    /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [END] */
  }

  /** 2023-06-30 sh #8385(BQR1118) chagen Katakana from Han to Zen. [START] */
  columnNm(nm: any) {
    return nm
    .replace('入庫予定日時', '入庫予定<br />日時')
    .replace('作業予定時間', '作業予定<br />時間')
    .replace('入庫履歴', '入庫<br />履歴');
  }
  /** 2023-06-30 sh #8385(BQR1118) chagen Katakana from Han to Zen. [END] */
}
